import { render } from "./report-timestamp.vue?vue&type=template&id=2b09e190&ts=true"
import script from "./report-timestamp.ts?vue&type=script&lang=ts"
export * from "./report-timestamp.ts?vue&type=script&lang=ts"

import "./report-timestamp.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__